export const SET_STEP_LEVEL = 'SET_STEP_LEVEL'
export const SET_PAYMENT_SETUP_STEP = 'SET_PAYMENT_SETUP_STEP'
export const SET_HOW_TO_PAY = 'SET_HOW_TO_PAY'
export const ENERGY_CREDITS_CHECK_BOX = 'ENERGY_CREDITS_CHECK_BOX'
export const COMMUNITY_FEE_CHECK_BOX = 'COMMUNITY_FEE_CHECK_BOX'
